import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/total_score/progress');
  return response.data;
}

export default {
  index,
};
